import Core from "../core";
import { AxiosError, AxiosResponse } from "axios";

async function upcomingEvents(empId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/dashboard/stats?full_path=true&emp_id=${empId}&locale=${localStorage.getItem(
      "emplang"
    )}`
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const upcomingEventsService = {
  upcomingEvents,
};
